import { Component, OnInit, Inject,ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-assign-client-to-campaign',
  templateUrl: './assign-client-to-campaign.component.html',
  styleUrls: ['./assign-client-to-campaign.component.scss']
})
export class AssignClientToCampaignComponent implements OnInit {

  authToken = localStorage.getItem('token')
  clientList:any;
  selectedClient:any;
  campaignDetails:any;
  btnStatus = false;
  constructor(
    private dialogRef: MatDialogRef<AssignClientToCampaignComponent>,
    private _serverService:ServerService,
    private clipBoardService:ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { 
    this.campaignDetails = this.data
    // console.log(this.campaignDetails)

  }

  ngOnInit() {
    this.getAllClients()
  }
  close() {
    this.dialogRef.close();
}
getAllClients(){
this._serverService.clientsGenericList(this.authToken).subscribe((data)=>{
 
  this.clientList = data.client;

})
}
apply(){
  this.btnStatus = true;
  let body = {
    // 'marketing_manager':this.selectedUser,
    // 'marketing_manager_id':this.selectedUser.id,
    // "campaign_id": this.data.id,
    // 'assigned_user':this.selectedUser,
    'client_id':this.selectedClient
  }
  let url = this.data.id;
  this._serverService.updateCampaignDetails(url,body,this.authToken).subscribe((data)=>{
      this.dialogRef.close(data);
      this.clipBoardService.showMessgeInText("Client Assigned Successfully", "success-snackbar")
   
  },
   error => {
    console.error('Client Assigned failed', error);
    this.btnStatus = false;
    // this.showComponentLoader = false;
  })

}
}
